import Model from './BaseModel'
import Customer from './Customer'
import Activation from './Activation'
import i18n from '@/plugins/i18n'
import moment from 'moment'

export default class CommissionItems extends Model {
    resourceName() {
        return 'items'
    }

    fields() {
        return [
            'reference',
            'activation_id',
            'commission_id',
            'customer_id',
            'value',
            'base_value',
            'period',
            'plan_value',
            'percent',
            'activation_value',
            'activation_installments',
            'current_installment',
            'paid_at',
        ]
    }

    relationships() {
        return {
            customer: new Customer(),
            activation: new Activation(),
        }
    }

    computed() {
        return {
            formattedValue(item) {
                return i18n.n(item.value, 'currency')
            },

            formattedBaseValue(item) {
                return i18n.n(item.base_value, 'currency')
            },

            type(item) {
                return item.activation_id
                    ? 'Ativação'
                    : 'Comissão sobre carteira'
            },

            formattedPaidAt(item) {
                if (item.paid_at) {
                    return moment(item.paid_at).format('DD/MM/YYYY')
                }

                return '-'
            },
        }
    }
}
